import React from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

export const useLoginFromMobile = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const isMyAccountFromMobile =
    location?.search?.includes('micuentafull') &&
    (searchParams.get('device_model') === 'android' ||
      searchParams.get('device_model') === 'aapl');

  return {
    isMyAccountFromMobile,
  };
};
